import { IDataTableColumn } from '../../dataTable/DataTable/model';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export interface ISeedRow extends Record<string, any> {
  onDelete?: (item: any) => void;
}

const seedColumns: IDataTableColumn<ISeedRow>[] = [
  { name: 'Autotreat MFR Seed Cloud ID', selector: (row) => row.autotreat_mfr_seed_cloud_id, sortable: true },
  { name: 'Global MFR ID', selector: (row) => row.global_mfr_id, sortable: true },
  { name: 'GTIN', selector: (row) => row.gtin, sortable: true },
  { name: 'Seed Variety Name MFR', selector: (row) => row.seed_variety_name_mfr, sortable: true },
  { name: 'Seed Variety Name Short', selector: (row) => row.seed_variety_name_short, sortable: true },
  { name: 'Seed Variety Desc', selector: (row) => row.seed_variety_desc, sortable: true },
  { name: 'Package', selector: (row) => row.package, sortable: true },
  { name: 'Crop ID', selector: (row) => row.crop?.crop_id, sortable: true },
  { name: 'Crop', selector: (row) => row.crop_name, sortable: true },
  { name: 'Locked', selector: (row) => row.locked, sortable: true, cell: (row) => (row.locked ? 'True' : 'False') },
  { name: 'Active', selector: (row) => row.active, sortable: true, cell: (row) => (row.active ? 'True' : 'False') },
  { name: 'Date and Time Created', selector: (row) => row.date_and_time_created, sortable: true },
  {
    name: 'Actions',
    selector: (row: ISeedRow) => '',
    cell: (row: ISeedRow) => {
      return (
        <Tooltip title="Delete Seed">
          <IconButton 
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              if (row.onDelete) {
                row.onDelete(row);
              } else {
                console.error('onDelete handler not found on row');
              }
            }}
            size="small"
            color="error"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      );
    },
    ignoreOnRowClick: true,
    allowOverflow: true,
    button: true,
  },
];

export default seedColumns;
